// Parse pasted text or CSV into [{full_name, email, role, cohort}] rows. Handles commas, tabs, semicolons and quotes.
const splitLine = (line, delim) => {
  const out = [];
  let cur = '';
  let q = false;
  for (let i = 0; i < line.length; i += 1) {
    const ch = line[i];
    if (ch === '"') {
      if (q && line[i + 1] === '"') { cur += '"'; i += 1; } else q = !q;
    } else if (ch === delim && !q) { out.push(cur.trim()); cur = ''; } else cur += ch;
  }
  out.push(cur.trim());
  return out;
};

const isEmail = (s) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(s || '');

export function parsePeople(text) {
  const lines = (text || '').split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  if (!lines.length) return [];
  const delim = ['\t', ';', ','].find((d) => lines[0].includes(d)) || ',';
  let cells = lines.map((l) => splitLine(l, delim));
  const head = cells[0].map((h) => h.toLowerCase().replace(/[^a-z]/g, ''));
  const hasHeader = !cells[0].some(isEmail) && head.some((h) => h.includes('email'));
  let idx;
  if (hasHeader) {
    const find = (...keys) => head.findIndex((h) => keys.some((k) => h === k || h.includes(k)));
    idx = { email: find('email'), name: find('fullname', 'name'), first: find('firstname'), last: find('lastname', 'surname'),
      role: find('role'), cohort: find('cohort') };
    if (idx.first >= 0 && idx.name === idx.first) idx.name = -1;
    cells = cells.slice(1);
  }
  return cells.map((c) => {
    if (!hasHeader) {
      const e = c.findIndex(isEmail);
      const email = e >= 0 ? c[e] : (c[1] || c[0] || '');
      const name = c.filter((_, i) => i !== e).join(' ').trim();
      return { full_name: name, email: email.toLowerCase(), role: '', cohort: '' };
    }
    const get = (i) => (i >= 0 ? c[i] || '' : '');
    const name = get(idx.name) || [get(idx.first), get(idx.last)].filter(Boolean).join(' ');
    return { full_name: name, email: get(idx.email).toLowerCase(), role: get(idx.role).toLowerCase(), cohort: get(idx.cohort) };
  }).filter((r) => r.email || r.full_name);
}

export { isEmail };
